import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";

import RadioButtons from "../framework/RadioButtonsObj";
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import webRootContext from "../components/webrootcontext/WebRootContext";
import { UPLOAD_VISA_OBJECT } from '../components/UploadVisaObject';
import FileUpload from "../framework/FileUpload";


function UploadVisa(props) {
  	const [saveSuccess, setSaveSuccess] = useState();
	const [saveFailed, setSaveFailed] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [responseError, setResponseError] = useState();
	const [isVisa, setIsVisa] = useState();
	const [isVisaObj, setIsVisaObj] = useState();
	const [thisAppId, setThisAppId] = useState();
	const [uploadVisaCompleted, setUploadVisaCompleted] = useState(false);
    const [applicationAccepted, setApplicationAccepted] = useState();
    const [applicationCompleted,  setApplicationCompleted] = useState(false);
    const [fileLabel, setFileLabel] = useState();
    const [visaErrorMessage,  setVisaErrorMessage]=useState(); 
    

  	let yesno_radio_button = [
    	{ id:1, value: 1, label: "Yes", name: "Yes", selected: false },
    	{ id:2, value: 0, label: "No", name: "No",  selected: false }
	];	
	
	const [uploadVisaObject, setUploadVisaObject] = useState(UPLOAD_VISA_OBJECT);
	const getApplicantIdUrl =  webRootContext + "/rest/dashboard/getApplicantId";
	const getDashboardStatusUrl =  webRootContext + "/rest/dashboard/getStatus";
	
	const boldStyle = {fontWeight: "bold",
	                   fontSize: "16px",
	                   };
	const linkElement = useRef();
	
	// required documents - file upload 
	const [visaUploaded, setVisaUploaded] = useState(false);
	const fileUploadInstructionMessage='Drag & Drop your file or <span class="filepond--label-action">Browse</span>';
	const fileUploadApi =  webRootContext + "/rest/fileUploadService/fileUpload/";
	const invalidFileLength = "The file name must be under 60 characters. Delete the file and upload a new one.";
	
	
	
	const visaHelpMessage = <span>If you’re not sure, visit the <a href="https://esta.cbp.dhs.gov/" target="_blank" rel="noopener noreferrer">ESTA</a> webpage to check your country’s status in the Visa Waiver Program.</span>;
	const saveSuccessContent = 
	<div>
		<div className="padding-bottom-30">Thank you for submitting a photocopy of your Visa or passport.</div>
		<div><Button text={"RETURN TO DASHBOARD"} styleName={"button button--primary"} id={"returnForm"} onClick={(e) => {returnToDashboard();}} /></div>
	</div>;
	
	const alreadySubmittedContent = 
	<div>
		<div className="padding-bottom-30">This task has already been submitted.</div>
			<Button
		       text={"RETURN TO DASHBOARD"}
		       styleName={"button button--primary"}
		       id={"button_submit"}
		       type="submit"
			   onClick={(e) => {returnToDashboard();}}
		       />
	</div>;

   const notApplicableContent = 
	<div>
		<div className="padding-bottom-30">Please return to the dashboard to view the status of your application and how to proceed.</div>
			<Button
		       text={"RETURN TO DASHBOARD"}
		       styleName={"button button--primary"}
		       id={"button_submit2"}
		       type="submit"
			   onClick={(e) => {returnToDashboard();}}
		       />
	</div>;
	useEffect(() => {
		    linkElement.current.style.setProperty("font-weight", "bold", "important");	//have to use ref,  the sytle object doesn't work for the font weight important css
			fetch(getApplicantIdUrl, {
					    method: 'GET', 
				   		headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json'
								},
						mode: "cors"})
					.then((response) => {
						return response.json();					
					})
					.then((data) => {	
						setThisAppId(data.applicantId);
						setApplicationCompleted(data.isApplicationCompleted);
						getDashboardStatusData(data.applicantId);
					},(error) => {
						console.log("dashboard error: ",  error);
					});	
					
		//Check to see if the user has already completed this step 
		function getDashboardStatusData(applicantId){
	       const url =  getDashboardStatusUrl + "?applicantId="+applicantId ;
		   let formCompleted = false;	
		   
           fetch(url, {
			    method: 'GET', 
		   		headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
						},
				mode: "cors"})
				.then((response) => {
					return response.json();					
				})
				.then((data) => {	
					
				
				setApplicationAccepted(data.applicantId > 0 && data.isAccepted);
				for(const item in data.requirementList)
				{
					if(data.requirementList[item].label === "Proof of Visa or Passport" && data.requirementList[item].status !== "notstarted")
				     {
						 formCompleted = true;
						 break;
					 }
				}
		   
		  	setUploadVisaCompleted(formCompleted);	 
				},(error) => {
					console.log("dashboard error: ",  error);
				});	  
   };
	
	}, [getApplicantIdUrl,thisAppId, getDashboardStatusUrl]); 
	  

  function returnToDashboard() {
      window.location.href = webRootContext + "/ApplicantDashboard";
  }                   


   function saveApplication(){
    	let url = webRootContext + "/rest/visaPassport/saveVisaPassport";

	 		fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: thisAppId,
	    		mode:"cors"})
 		 .then((response) => {
			 
			  if(response.ok){
					setSaveSuccess(true);
	    			setSaveFailed(false);
			   }
			   else{
				   console.log("saving response header:", response.headers);		   
					setResponseError(response.headers.get('error'));
					setSaveSuccess(false);
		    		setSaveFailed(true);
			   }
			   
			    return response.json();
		 })
 		 .catch((err) => {
          	console.log("error", err); 
	  		}	
    	  );
  	
	}

  return (
     <div>
     	<div id="completed" className={ !applicationCompleted && uploadVisaCompleted ? 'show_div' : 'hide_div'}>
         	<div id="alreadySubmittedDiv" className="div_1_col">
				<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={alreadySubmittedContent} />
			</div>
         </div>
         
         <div id="noAcceptedApplication" className={ !applicationCompleted && (applicationAccepted || applicationAccepted === undefined) ? 'hide_div':'show_div' }>
         	<div id="notApplicableDiv" className="div_1_col">
				<Ribbon label="RETURN TO DASHBOARD" status={"error"} subheader={""} content={notApplicableContent} />
			</div>
         </div>
         
	     <div id="formikForm" className={ applicationCompleted || uploadVisaCompleted || !applicationAccepted  ? 'hide_div' : 'show_div'}>
	        <Formik 
	        	enablereinitialize={true}
	        	
			 	initialValues={{
				  visaRequired: "",
				  visaUploaded:  visaUploaded
				 }}
				 
				 validate={values => {
	         		const errors = {};
	         		setFormikError(false);
	         		
	            
				if (!values.visaRequired) {errors.visaRequired = 'Visa question is required';}
				
				// using values.cvUploaded doesn't work. we have to use a flag to do the check
				if (isVisa===1 || isVisa === 0) {
				    if (!visaUploaded) {errors.visaUploaded = visaErrorMessage;}
					}
				 
			     if( Object.keys(errors).length > 0) {
					setFormikError(true);
				  } else {
			          setFormikError(false);
			      }	
	
			     return errors;
			   }}
				 
				onSubmit={(values, { setSubmitting}) => {
		                    setTimeout(() => {                     
		                        saveApplication();
		                        setSubmitting(false);			     	            	
		                        }, 100);
				        
		                }}
				 >
	          {({
	            values /* all data need to run the valdation*/,
	            errors /* all error strings */,
	            touched /* all field touch event  */,
	            handleChange /* value change event handler */,
	            handleBlur /* onBlur event handler */,
	            handleSubmit /* for submit button */,
	            isSubmitting /* for submit button */,
	            isValid /* for submit button */,
	            dirty /* for submit button */,
	            validateForm,
	            setFieldValue,
	            setFieldError
	          }) => (
	          
			<form onSubmit={handleSubmit} noValidate>
	           
				<div id="submitFailed" className={(saveFailed ? 'show_div' : 'hide_div')}>
					<div id="failDiv" className="div_1_col">
						<Ribbon label={responseError} status={"error"} subheader={""} content={""} />
					</div>
				</div>
		   
				<div id="formikErrors" className={(formikError && formSubmitted? 'show_div' : 'hide_div')}>
					<div id="formikFailDiv" className="div_1_col">
	           			<Ribbon label={"REVIEW ISSUES BELOW"} status={"error"} subheader={""} content={""} />
					</div>
				</div>
	
				<div id="saveSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
					<div id="saveSuccessDiv" className="div_1_col">
						<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={saveSuccessContent} />
					</div>
				</div>
	
				<div id="headerDiv" className={saveSuccess ? 'hide_div' : 'show_div div_1_col'}>
					<div className="breadcrumbLink"><a href="##" onClick={(e) => {returnToDashboard();}}>Dashboard</a></div>         
					<div className="page_title">Proof of Visa or Passport</div>
				</div>
	
				<div id="formInputs" className={(saveSuccess ? 'hide_div div_3_col' : 'show_div div_3_col' )} >
				
					<div id="divPageInfo" className="normal_txt padding-bottom-30">Based on your citizenship, you are required to submit either a photocopy of your visa or passport. Answer the question below to determine the correct document.</div>
	
	             	<div id="div1">
			        	<RadioButtons
			                id={"visaRequired"}
			                label={"Does your country require you to obtain a visa to visit the United States?"}
			                name="visaRequired"
			                // init data array setup radio buttons
			                data={yesno_radio_button}
			                isRequired={true}
			                layoutVertical={false}
			                selectedItem={isVisaObj}
			                helpMessage={visaHelpMessage}
			                value={(e) => {
			                }}
			                onChange={(e) => {
								errors.visaRequired = "";
							  values.visaRequired = e;
							  setFieldError("visaRequired",  null);
			                  if (e) {
								  setIsVisa(e.value);
								  setIsVisaObj(e);		
								  setUploadVisaObject({...uploadVisaObject, thisVisa: e.value});
								  
								  setFieldError("visaUploaded",  null);
								  if(e.value === 1) {
									  setFileLabel("Upload a photocopy of your visa at least 30 days prior to your start date");
									  setVisaErrorMessage("Photocopy of visa is required");
								  }else {
									  setFileLabel("Upload a photocopy of the information page of your passport at least 30 days prior to your start date");
									  setVisaErrorMessage("Photocopy of passport is required");
								  }
			                  }
							}}
	
			                // if touched and has error
			                hasError={touched.visaRequired && errors.visaRequired}
			                // get error message from errors
			                errorMessage={errors.visaRequired}
			                // on forcus, change touched to true
			                onFocus={(e) => {
			                  touched.visaRequired = e;
			                }}
			                 onBlur={(e) => { 						
								touched.visaRequired = e;
								validateForm();
							}}
			              />
					</div>
					
	
					<div id="div3" className={(uploadVisaObject.thisVisa === 1 ? 'show_div' : 'hide_div' )} >             	
					<div id="div3content" className="padding-bottom-30 normal_txt">We recommend applying for a B1 or B1/B2 visa. If you are planning on entering the United States under any other visa, please notify the Observership Program office in advance. For more information please visit the <a href="https://www.state.gov/" target="_blank" rel="noopener noreferrer">U.S. Department of State</a> webpage.</div>
					</div>
					
					<div id="div4" className={(uploadVisaObject.thisVisa !== '' ? 'show_div' : 'hide_div' )} >
					<div id="div4content">
	             		<FileUpload
						    id="visaUploaded"
			                label={fileLabel}
			                name="visaUploaded"
			                isRequired={true}
			                numberOfFiles={1}
			                fileSize={"2MB"} // default 2MB each file
			                maxFileNameLength={60} //Database column that stores the file name is limited to 100
			                fileType={["pdf", "image_basic"]}			
			                instructionMessage={fileUploadInstructionMessage}
			                helpMessage={"File format: .pdf, jpg (limit 1 file under 2 MB)"}
			                hasError={touched.visaUploaded && errors.visaUploaded}
			                errorMessage={errors.visaUploaded}
			                uploadApi={fileUploadApi + "visa"} 
							onChange={(e) => {
								//return array of file, no file: [];  valida file:  e.length == 1, e[0] is file object; on error,  return error .   invalid file: e is error message/status == "file is of..."
							    
								let tmp = e && e.length > 0 && e[0]!== 'F' && e[0].filename.length < 60;
								setVisaUploaded(tmp ? true : false);
							    
								touched.visaUploaded = true;
								if(!tmp){
									if(e.length === 0){
										setFieldError("visaUploaded",  visaErrorMessage);
									}
									else if (e[0].filename.length > 60){
										setFieldError("visaUploaded", invalidFileLength );	//need to display field error when fileupload on change	
									}
									else{
										setVisaErrorMessage("Upload a .pdf, or jpg (limit 1 file under 2 MB)");
										setFieldError("visaUploaded", visaErrorMessage );	//need to display field error when fileupload on change	
									}
																
								}else{
									setFieldError("visaUploaded", null);											
								}							
							   
							}}
							onBlur={(e) => {
								
							}}
							
							
			              />
			        </div>
					</div>
	
					<div id="div6" className={(uploadVisaObject.thisVisa === 0 ? 'show_div' : 'hide_div' )} >             	
					<div id="div6content" style={boldStyle} className="padding-bottom-30">
						In addition to submitting a photocopy of your passport, you must register your trip in the <a href="https://esta.cbp.dhs.gov/" ref={linkElement}     
                        target="_blank" rel="noopener noreferrer" style={boldStyle}>Electronic System for Travel Authorization (ESTA)</a>.</div>
					</div>
	
	
	              <hr className="hr--light" />
	              <div id="divButton">
			          <Button
		                text={"SUBMIT PHOTOCOPY"}
		                styleName={"button button--primary"}
		                id={"button_submit"}
		                type="submit"
		               onClick={(e) =>{setFormSubmitted(true); setSaveFailed(false); validateForm();window.scrollTo({top: 0, left: 0, behavior: 'auto'}); }}
		              />
	              </div>
	            </div>
	            </form>
	          )}
	        </Formik>
	      </div>
	     </div>
  );
}

export default UploadVisa;